import { AppForm } from '../../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';

export class VehicleForm extends AppForm {
  public vehicleCategories: string[] = [
    'Pojazd wolnobieżny',
    'Ciągnik rolniczy',
    'Przyczepa specjalna'
  ];

  constructor() {
    super({
      vehicleCategory: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      vehicleType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      registrationNumberOrChassisNumber: new FormControl('', { nonNullable: true, validators: [Validators.required] })
    });
  }
}
